<template>
  <div class="pspgl-Loader">
    <div v-for="row in ROW_COUNT" :key="`row-${row}`" class="pspgl-Row">
      <div v-for="cell in columnCount" :key="`row-${row}-cell-${cell}`" class="pspgl-Cell">
        <SkeletonItem :size="XS" width="64px" />
        <SkeletonItem :size="XS" width="36px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { SKELETON_SIZES } from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'PersonalStatisticsProgressViewGridLoader'
})

defineProps({
  columnCount: {
    type: Number,
    required: true
  }
})

const { XS } = SKELETON_SIZES

const ROW_COUNT = 5
</script>

<style lang="scss" scoped>
.pspgl-Row {
  display: flex;
  height: var(--cdpm-row-height, 64px);
}

.pspgl-Cell {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: var(--pmcc-cell-padding, 12px);
}
</style>
